import * as components from "./components"
import * as containers from "./containers"
import reducer from "./reducer"
import * as constants from "./constants"
import * as actions from "./actions"

const content = { components, reducer, constants, actions, containers }
export default content
export const AppNavigator = components.AppNavigator
